<template>
    <div style="position: relative;">
        <div class="showTime">
            <div>{{ timeFindMin }}</div>
            <div>{{ timeFindMax }}</div>
        </div>
        <div class="highcharts-container">
            <div id="chart-container" ref="chartContainer"></div>
        </div>
    </div>
</template>

<script>
import { TimeData } from '@/plugins/timeFun.js'
// 导入基础的Highcharts
import Highcharts from 'highcharts';

// 首先导入并初始化Boost模块 - 添加.default属性
import HighchartsBoost from 'highcharts/modules/boost';
HighchartsBoost.default(Highcharts);

// 然后导入并初始化Stock模块 - 添加.default属性
import HighchartsStock from 'highcharts/modules/stock';
HighchartsStock.default(Highcharts);

// 导入并初始化Accessibility模块 - 添加.default属性
import HighchartsAccessibility from 'highcharts/modules/accessibility';
HighchartsAccessibility.default(Highcharts);

// 导入并初始化Exporting模块 - 添加.default属性
import HighchartsExporting from 'highcharts/modules/exporting';
HighchartsExporting.default(Highcharts);

// 确保全局可用
window.Highcharts = Highcharts;
export default {
    name: 'HighchartsComponent',
    props: {
        titles: {
            type: String,
            default: () => ('')
        }
    },
    data() {
        return {
            timeFindMin: '',
            timeFindMax: '',
            chartContainer: null,
            chart: null,
            maxLineId: [], // 上限虚线id(方便删除)
            minLineId: [], // 下限虚线id(方便删除)
        };
    },
    mounted() {
        this.initChart();
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    },
    methods: {
        // 初始化图表
        initChart() {
            // 使用Highcharts.stockChart()而不是Highcharts.chart()
            this.chart = Highcharts.stockChart(this.$refs.chartContainer, {
                chart: {
                    zooming: { type: "x" },
                    animation: true,
                    height: '500px',
                    type: 'line', // 图表类型,column,line,spline,area等

                    panning: true,  // 启用平移功能
                    panKey: 'shift', // 设置平移快捷键为Shift

                    events: {
                        redraw: function (e) {
                            // console.log('===== Boost模块检查 =====');
                            // if (this && this.boost) {
                            //     console.log('Boost模块已在图表实例中启用');
                            //     console.log('Boost配置:', this.boost);
                            //     // 检查是否使用Boost渲染
                            //     if (this.series && this.series.length > 0) {
                            //         const boostUsed = this.series.some(s => s.isBoosting);
                            //         console.log('是否在使用Boost渲染:', boostUsed);
                            //     }
                            // } else {
                            //     console.log('图表实例中未找到boost配置');
                            // }
                        }
                    },
                    scrollablePlotArea: {
                        minWidth: 500, // 设置最小宽度，确保在小屏幕上可以滚动查看
                        scrollPositionX: 1 // 默认显示最左侧
                    }
                },
                boost: {
                    enabled: true,                  // 启用Boost模块
                    useGPUTranslations: true,       // 使用GPU进行平移/缩放操作
                    usePreAllocated: true,          // 预分配WebGL缓冲区
                    // seriesThreshold: 3,     // 当系列数量达到3个时才启用Boost
                    // force: false,           // 取消强制Boost，让Highcharts智能决定
                    // allowForce: false,      // 不允许强制启用
                    // useGPUTranslationsByDefault: false, // 禁用默认GPU平移以提高兼容性
                    // debug: false
                },
                accessibility: {
                    enabled: true
                },
                title: {
                    text: '',
                    align: "center"
                },
                subtitle: {
                    text: '',
                    align: "center"
                },
                exporting: {
                    enabled: false // 用来设置是否显示'打印','导出'等
                },
                legend: {
                    // 图例
                    layout: "horizontal",
                    verticalAlign: "top",
                    enabled: true,
                    align: "left",
                    y: 0,
                    x: 22,
                    floating: false,
                    itemStyle: {
                        fontSize: "12px",
                        fontWeight: "500"
                    }
                },
                // Stock特有的rangeSelector配置
                rangeSelector: {
                    buttons: [
                        // { count: 1, type: "day", text: "1天" },
                        // { count: 7, type: "day", text: "7天" },
                        // { count: 1, type: "month", text: "1月" },
                        // { type: "all", text: "全部" }
                    ],
                    // selected: 3, // 默认显示全部数据
                    inputEnabled: false // 不显示日期输入框
                },
                credits: {
                    // 去掉右下角的Highcharts.com这个logo
                    enabled: false
                },
                // Stock特有的navigator配置
                navigator: {
                    enabled: true,
                },
                // Stock特有的scrollbar配置(滚动条)
                scrollbar: {
                    enabled: false
                },
                xAxis: {
                    type: "datetime",
                },
                yAxis: {
                    title: {
                        text: this.titles == '温度' ? "温度℃" : "湿度Rh"
                    },
                    // max: 30,
                    // min: -5,
                    opposite: false, // 设置y轴提示在左边
                    // plotLines: this.plotLines,
                    // 添加这个配置确保Y轴能够动态调整
                    allowDecimals: true,
                    // tickPixelInterval: 50,
                    plotLines: [], // 添加plotLines标示线
                },
                time: {
                    useUTC: false
                },
                tooltip: {
                    valueDecimals: 1, // 保留小数位数
                    enabled: true,
                    valueSuffix: this.titles == '温度' ? "℃" : "Rh",
                    animation: false,
                    // 添加以下配置来设置弹窗大小
                    // width: 200, // 固定宽度，单位px
                    // height: 100, // 固定高度，单位px
                    // style: {
                    //     maxWidth: '500px', // 最大宽度
                    //     padding: '20px', // 内边距
                    //     fontSize: '20px' // 字体大小
                    // },
                    // dateTimeLabelFormats: {
                    //     millisecond: "%Y-%m-%d %H:%M:%S.%L",
                    //     second: "%Y-%m-%d %H:%M:%S",
                    //     minute: "%Y-%m-%d %H:%M:%S",  // 强制显示秒
                    //     hour: "%Y-%m-%d %H:%M:%S",    // 强制显示秒
                    //     day: "%Y-%m-%d %H:%M:%S",     // 强制显示秒
                    //     week: "%Y-%m-%d",
                    //     month: "%Y-%m",
                    //     year: "%Y"
                    // },
                    formatter: function () {
                        // 使用JavaScript的Date对象格式化时间戳
                        const date = new Date(this.points[0].x);
                        // 自定义时间格式 - 年-月-日 时:分:秒
                        const formattedTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

                        var s = formattedTime + '<br/>';
                        for (let i in this.points) {
                            // 添加系列索引信息
                            s += '<br/>' + `<div style='color:${this.points[i].series.color};'>${this.points[i].series.name}  ：${(this.points[i].y).toFixed(1)}°C</div>`;
                        }

                        return s;
                    },
                    shared: true
                },
                plotOptions: {
                    series: {
                        animation: true,
                        // enableMouseTracking: true, // 改为true，启用鼠标跟踪
                        dataGrouping: {
                            enabled: false
                            // approximation: "sum"
                        },
                        tooltip: {
                            enabled: false
                        },
                        marker: {
                            enabled: true, // 改为true，启用数据点标记
                            radius: 3, // 设置小半径以提高性能
                            hover: {
                                enabled: true, // 悬停时启用标记
                                radius: 3 // 悬停时放大标记
                            }
                        },
                    }
                },
                series: []
            });
        },
        toggleNavigator(show) {
            if (this.chart && this.chart.navigator) {
                this.chart.update({
                    navigator: {
                        enabled: show
                    }
                });
            }
        },
        // 添加y轴的max/min值
        maxMinline(type, data) {
            if (!data) return;
            let { temp_min, temp_max, humidity_max, humidity_min } = data;

            let line = this.chart.yAxis[0].userOptions.plotLines;
            const res = [...new Set(line.map(item => item.value))]

            let maxl = [...res, type == 't' ? temp_max : humidity_max];
            let minl = [...res, type == 't' ? temp_min : humidity_min];

            this.chart.yAxis[0].update({
                max: Math.max(...maxl),
                min: Math.min(...minl),
            }, false); // true表示带动画效果
        },
        // 添加数据系列方法用于添加新的数据系列
        async addDataSeries(name, newData) {
            if (newData.length === 0) return;
            const index = this.chart.series.findIndex(s => s.name == name);
            if (index !== -1) {
                // 使用官方API更新数据，不要直接操作data属性
                // this.chart.series[index].setData(newData, false, false, false);
                this.removeDataSeries(name)
            }
            this.chart.addSeries({
                data: newData,
                lineWidth: 1.5, // 线宽
                name: name,
                animation: false, // 大数据量下禁用动画
                // marker: {
                //     enabled: true, // 大数据量下禁用数据点标记
                //     radius: 2.5
                // },
            }, false);

            this.timesFn()//更新时间范围

        },

        // 移除曲线---移除曲线时同时移除上下限虚线
        async removeDataSeries(name) {
            if (name !== undefined && name !== '') {
                const series = this.chart.series.find(s => s.name == name);
                if (series) {
                    this.removeLine(series.name); // 删除上下限虚线
                    series.remove(false); // 移除曲线(false表示不重绘)

                    // 当删除第一条曲线数据后，如果还有其他数据存在图表上，确保navigator正常显示
                    if (this.chart.series.length > 0) {
                        // 重新设置x轴范围
                        this.chart.xAxis[0].setExtremes(null, null);
                        // 确保navigator组件正确初始化
                        if (this.chart.navigator && this.chart.navigator.series) {
                            this.chart.navigator.update({
                                enabled: true
                            });
                        }
                    }
                    this.timesFn()//更新时间范围
                    return true;
                }
            }
            return false;
        },

        // 添加上限(线)
        addPlotLineFn(name, newData) {
            let lines = this.chart.yAxis[0].userOptions.plotLines;
            const line = lines.find(item => item.id == name);
            if (line != undefined) {//存在这个名字的标线，先删除再添加
                this.removeLine(name);//删除标线
            }

            this.chart.yAxis[0].addPlotLine({
                id: name, // 上限虚线id，当前取值为name
                value: newData[0][3],
                color: 'red',
                width: 1,
                dashStyle: 'solid',
                zIndex: 4,
                label: {
                    text: ` 上限:${newData[0][3]}`,
                    align: 'right',
                    style: { color: 'red' }
                }
            });
            this.chart.yAxis[0].addPlotLine({
                id: name, // 下限虚线id，当前取值为name
                value: newData[0][2],
                color: 'red',
                width: 1,
                dashStyle: 'solid',
                zIndex: 4,
                label: {
                    text: `下限:${newData[0][2]}`,
                    align: 'right',
                    style: {
                        color: 'red'
                    }
                }
            });


        },
        // 移除上下限
        removeLine(id) {
            this.chart.yAxis[0].removePlotLine(id);
        },
        //设置副标题
        setTitlefn(tit, sub) {
            this.chart.setTitle(
                { text: tit + '度曲线图' }, // 保持主标题不变
                {
                    text: !sub ? '' :
                        ` <div style="display: flex;align-items: center;justify-content: center;color: rgb(63, 177, 124);">
                            <div style="margin-right: 60px;">最高${tit}度:${tit == '温' ? sub.temp_max + '℃' : sub.humidity_max + 'Rh'}，</div>
                            <div style="margin-right: 60px;">最低${tit}度:${tit == '温' ? sub.temp_min + '℃' : sub.humidity_min + 'Rh'}，</div>
                            <div style="margin-right: 60px;">平均${tit}度:${tit == '温' ? sub.temp_avg + '℃' : sub.humidity_avg + 'Rh'}，</div>
                        </div>`
                }, false
            );
        },

        // 更新时间范围
        timesFn() {
            let maxtime = []
            let mintime = []
            let arr = this.chart.series.filter(item => item.name != 'Navigator 1');
            arr.map(item => {
                maxtime.push(item.xData[item.xData.length - 1])
                mintime.push(item.xData[0])
            })
            this.timeFindMin = mintime.length > 0 ? TimeData(Math.min(...mintime)) : null
            this.timeFindMax = maxtime.length > 0 ? TimeData(Math.max(...maxtime)) : null
        }
    }
};
</script>

<style scoped>
.highcharts-container {
    width: 100%;
}

.btn {
    padding: 8px 16px;
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.btn:hover {
    background-color: #45a049;
}

.btn:active {
    background-color: #3e8e41;
}

.showTime {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* color: rgb(63, 177, 124); */
    color: #666;
    position: absolute;
    left: 60px;
    top: 10%;
    right: 10px;
    z-index: 9;
}
</style>
